import type { PropsWithChildren } from 'react';
import type React from 'react';

import { useFocusFallbackListener } from './hooks';

export const FocusFallbackListener: React.FC<PropsWithChildren<EmptyProps>> = ({ children }) => {
	useFocusFallbackListener();

	return <>{children}</>;
};
